/**
 * Shared utility for determining zip code types
 */

import {
	CANADA_POSTAL_CODE_REGEX,
	US_ZIP_CODE_REGEX,
} from '@adflow/shared/data-salesforce-import';

export function determineZipCodeType(zipCode: string): 'US' | 'CA' | 'Unknown' {
	if (US_ZIP_CODE_REGEX.test(zipCode)) {
		return 'US';
	} else if (CANADA_POSTAL_CODE_REGEX.test(zipCode)) {
		return 'CA';
	} else {
		return 'Unknown';
	}
}
